"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultLanguage = exports.DEFAULT_LANGUAGES = exports.supportedLanguagesByCountry = exports.LANGUAGES = void 0;
const lib_custom_types_1 = require("@backend/lib-custom-types");
exports.LANGUAGES = (0, lib_custom_types_1.strictUnionArray)()(['FR', 'IT', 'EN', 'ES']);
exports.supportedLanguagesByCountry = {
    FR: ['FR'],
    IT: ['IT'],
    US: ['EN', 'ES'],
};
exports.DEFAULT_LANGUAGES = {
    FR: 'FR',
    IT: 'IT',
    US: 'EN',
};
const getDefaultLanguage = (country) => exports.DEFAULT_LANGUAGES[country];
exports.getDefaultLanguage = getDefaultLanguage;
